import Compile from '../src/compile';

var compiler = Compile({
	entry: {
		path: "./lib/tests/static/",
		file: "index.html"
	},
	output: "./lib/tests/output.html"
})

compiler.watch((err:any, stats:any)=>{
	console.log("Copmiled");
});